export const GA_EVENTS = {
    // Login Flow Events
    CLASSIFIED_LEAD_INITIATED: {
        event: "classified_lead_initiated",
        eventCategory: "classifieds",
        eventAction: "Source",
        eventLabel: "" // Source: Location/CDP_dealer_profile/Checkout/Service History
    },

    CLASSIFIED_LEAD_INITIATED_SCREEN_TYPE: {
        event: "classified_lead_initiated",
        eventCategory: "classifieds",
        eventAction: "screen_type",
        eventLabel: "" // email_name_phone/name_phone/phone
    },

    CLASSIFIED_OTP_INITIATED: {
        event: "classified_lead_initiated",
        eventCategory: "classifieds",
        eventAction: "otp_initiated",
        eventLabel: "" // appointmentId
    },

    CLASSIFIED_LEAD_NAME_ENTERED: {
        event: "classified_lead_name_entered",
        eventCategory: "classifieds",
        eventAction: "App id",
        eventLabel: "" // App id
    },

    CLASSIFIED_EMAIL_ENTERED: {
        event: "classified_email_entered",
        eventCategory: "classifieds",
        eventAction: "App id",
        eventLabel: "" // App id
    },

    CLASSIFIED_PHONE_NUMBER_ENTERED: {
        event: "classified_phone_number_entered",
        eventCategory: "classifieds",
        eventAction: "Click",
        eventLabel: "" // App id
    },

    CLASSIFIED_OTP_ENTERED: {
        event: "classified_otp_entered",
        eventCategory: "classifieds",
        eventAction: "App id",
        eventLabel: "" // App id
    },

    CLASSIFIED_LEAD_COMPLETED: {
        event: "classified_lead_completed",
        eventCategory: "classifieds",
        eventAction: "Order id",
        eventLabel: "" // Lead id
    }
};
